import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=b577eeee&scoped=true&"
import script from "./Memory.vue?vue&type=script&lang=js&"
export * from "./Memory.vue?vue&type=script&lang=js&"
import style0 from "./Memory.vue?vue&type=style&index=0&id=b577eeee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b577eeee",
  null
  
)

export default component.exports